module.exports = __webpack_public_path__ + "static/baranski-smart-84274d18af1cc7b6c9a4b85ef514e9d1.svg";